import { AppBar, Button, Grid, Menu, MenuItem } from "@material-ui/core";
import logo from "assets/imgs/icon.png";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import ColoredDivider from "views/ColoredDivider/ColoredDivider";

export default function Navbar() {
  const router = useHistory();
  const [quadrosMenu, setQuadrosMenu] = useState(null);
  const [categoriasMenu, setCategoriasMenu] = useState(null);
  const [anunciantesMenu, setAnunciantesMenu] = useState(null);

  const handleClose = () => {
    setQuadrosMenu(null);
    setCategoriasMenu(null);
    setAnunciantesMenu(null);
  };

  const redirect = (url) => {
    handleClose();
    router.push(url);
  };

  const quadros = [
    { label: "Loop Comedy", id: "0001", url: "loop-comedy" },
    { label: "Loop Imóveis", id: "0002", url: "loop-imoveis" },
    { label: "Loop Sports", id: "0003", url: "loop-sports" },
  ];
  const categorias = [
    { label: "Eletrônicos", id: "0001", url: "eletronicos" },
    { label: "Móveis", id: "0002", url: "moveis" },
    { label: "Imóveis", id: "0003", url: "imoveis" },
  ];
  const anunciantes = [
    { label: "Xiaomi", id: "0001", url: "xiaomi" },
    { label: "Grupo Kallas", id: "0002", url: "grupo-kallas" },
    { label: "Click Keys", id: "0003", url: "click-keys" },
  ];

  return (
    <div>
      <AppBar color="primary" position="relative">
        <Grid container alignItems="flex-start" justifyContent="flex-start">
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Button onClick={() => router.push("/")}>
              <img src={logo} alt="Loop TV" style={{ maxWidth: "150px" }} />
            </Button>
          </Grid>
          <Grid item xs={12}>
            <ColoredDivider />
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              alignItems="flex-start"
              justifyContent="flex-start"
              style={{ textAlign: "center" }}
            >
              <Grid item xs={4} style={{ textAlign: "center" }}>
                <Button
                  variant="text"
                  fullWidth
                  color="secondary"
                  onClick={(e) => setQuadrosMenu(e.currentTarget)}
                  style={{ color: "#ffdd00" }}
                >
                  Quadros
                </Button>
              </Grid>
              <Grid
                item
                xs={4}
                style={{ textAlign: "center" }}
                onClick={(e) => setCategoriasMenu(e.currentTarget)}
              >
                <Button
                  variant="text"
                  fullWidth
                  color="secondary"
                  style={{ color: "#ff00ea" }}
                >
                  Categorias
                </Button>
              </Grid>
              <Grid
                item
                xs={4}
                style={{ textAlign: "center" }}
                onClick={(e) => setAnunciantesMenu(e.currentTarget)}
              >
                <Button
                  variant="text"
                  fullWidth
                  color="secondary"
                  style={{ color: "#00f7ff" }}
                >
                  Anunciantes
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <Menu
        anchorEl={quadrosMenu}
        keepMounted
        open={Boolean(quadrosMenu)}
        onClose={handleClose}
        style={{ color: "white" }}
      >
        {quadros.map((quadro) => {
          return (
            <MenuItem
              onClick={() => redirect("/quadro/" + quadro.url)}
              style={{ color: "white" }}
            >
              {quadro.label}
            </MenuItem>
          );
        })}
      </Menu>
      <Menu
        anchorEl={categoriasMenu}
        keepMounted
        open={Boolean(categoriasMenu)}
        onClose={handleClose}
        style={{ color: "white" }}
      >
        {categorias.map((categoria) => {
          return (
            <MenuItem
              onClick={() => redirect("/categoria/" + categoria.url)}
              style={{ color: "white" }}
            >
              {categoria.label}
            </MenuItem>
          );
        })}
      </Menu>
      <Menu
        anchorEl={anunciantesMenu}
        keepMounted
        open={Boolean(anunciantesMenu)}
        onClose={handleClose}
        style={{ color: "white" }}
      >
        {anunciantes.map((anunciante) => {
          return (
            <MenuItem
              onClick={() => redirect("/anunciante/" + anunciante.url)}
              style={{ color: "white" }}
            >
              {anunciante.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
